<script>
import ProductCategoryProviderModal
    from "@core/components/common/expression-language/value-provider/ProductCategoryProviderModal.vue";
import {BFormGroup, BFormInput, BFormTextarea, BFormCheckbox} from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
export default {
    components: {Button, ProductCategoryProviderModal, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox},
    data() {
        return {
            onlySelectable: true,
            generated: null
        }
    },
    methods: {
        handle(list) {
            this.generated = list;
            this.$emit('input', '[' + list.join(', ') + ']');
        }
    }
}
</script>

<template>
    <div>
        <div>
            <b-form-checkbox
                class="custom-control-success"
                v-model="onlySelectable"
                switch
                inline
            >Show only selectable items</b-form-checkbox>
        </div>

        <div class="float-right">
            <Button @click="$refs.ProductCategoryProviderModal.show()">Open selector</Button>
        </div>

        <ProductCategoryProviderModal
            :only-selectable="onlySelectable"
            ref="ProductCategoryProviderModal"
            @input="handle"
        />
    </div>
</template>
